import Rodape from "../../components/rodape";
import BannerProjects from "../../components/bannerProjects";
import BusinessOtimize from "../../components/businessOtimize";
import ErpMarcas from "../../components/erpMarcas";
import ComoFazemos from "../../components/comoFazemos";
import CardsAms from "../../components/cardsAms";

function Ams() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-ams.png"
                bgMobile="../assets/cover-ams-mobile.png"
                title="/AMS"
                titleBold=""
                iconSrc="../assets/icone-projectiva-omnicore.png"
                iconAlt="Projectiva Omnicore"
                iconText="omni"
                iconTextBold="core"
                descriptionBold=""
                description={
                    <>
                        <span className="font-titillium-web-bold">
                            AMS (Application Management Services)
                        </span>{" "}
                        é a gestão e sustentação do ERP em operação, com foco em
                        correções, melhorias e suporte técnico-funcional. Na
                        Omnicore, vamos além de um contrato de suporte: atuamos
                        como extensão estratégica da operação, com performance,
                        visão de negócio e compromisso real com SLAs.
                    </>
                }
                footerText="VERTICAL SOLUTIONS | ERP Excellence Center"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]"
                brand="omnicore"
            />
            <ComoFazemos
                title={
                    <>
                        Como{" "}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB]">
                            fazemos?
                        </span>
                    </>
                }
                cards={[
                    {
                        icon: "/assets/servicos/abordagem2_icon.svg",
                        iconHover: "/assets/servicos/abordagem2_icon.svg",
                        title: "Abordagem",
                        text: (
                            <>
                                <p>
                                    <span className="font-inter-bold">
                                        Nosso modelo de AMS é proativo,
                                        consultivo e orientado à performance.
                                    </span>
                                </p>
                                <p className="mt-2">
                                    Não operamos como um call center técnico,
                                    somos uma extensão do time do cliente, com
                                    profundo entendimento dos processos de
                                    negócio, do contexto operacional e dos
                                    impactos de cada demanda.
                                </p>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "420",
                    },
                    {
                        icon: "/assets/servicos/foco_icon.svg",
                        iconHover: "/assets/servicos/foco_icon.svg",
                        title: "Foco",
                        text: (
                            <>
                                <p>
                                    Focamos em{" "}
                                    <span className="font-inter-bold">
                                        resolver com inteligência, não apenas
                                        atender
                                    </span>
                                    . Com times sêniores e foco na causa raiz,
                                    reduzimos reincidência de problemas e
                                    otimizamos o ERP. Aqui, SLA é compromisso,
                                    não protocolo.
                                </p>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "420",
                    },
                    {
                        icon: "/assets/servicos/entrega_icon.svg",
                        iconHover: "/assets/servicos/entrega_icon.svg",
                        title: "Entrega",
                        text: (
                            <>
                                <p>
                                    Entregamos respostas rápidas, ações
                                    corretivas e evolução real, com gestão
                                    ativa, indicadores e priorização
                                    estratégica. Nosso diferencial está na{" "}
                                    <span className="font-inter-bold">
                                        escala de resolução que criamos:
                                    </span>{" "}
                                    mais agilidade, profundidade técnica e menos
                                    burocracia que os modelos tradicionais.
                                </p>
                            </>
                        ),
                        glowColor: "#4B3BDB",
                        height: "420",
                    },
                ]}
            />
            <ErpMarcas />
            <BusinessOtimize
                title={
                    <>
                        <span className="font-inter-bold">
                            Seu ERP funcionando continuamente com eficiência e
                            efetividade,
                        </span>{" "}
                        gerando resultados de impacto para o seu negócio.
                    </>
                }
                buttonText="Otimize seu negócio!"
                buttonTextColor="from-[#4B3BDB] to-[#4B3BDB]"
                backgroundImage="../assets/banner-erp-otimize.png"
                bgMobile="../assets/banner-erp-otimize-mobile.png"
                buttonLink="/"
            />
            <CardsAms
                cards={[
                    {
                        title: "Atuação preditiva",
                        icon: "../assets/servicos/atuacao_icon.svg",
                        iconHover: "../assets/servicos/atuacao_icon.svg",
                        glowColor: "#4B3BDB",
                        height: "250",
                        width: "250",
                    },
                    {
                        title: "Atendimento de ocorrências",
                        icon: "../assets/servicos/atendimento_icon.svg",
                        iconHover: "../assets/servicos/atendimento_icon.svg",
                        glowColor: "#4B3BDB",
                        height: "250",
                        width: "250",
                    },
                    {
                        title: "Implementação de melhorias contínuas",
                        icon: "../assets/servicos/implementacao_icon.svg",
                        iconHover: "../assets/servicos/implementacao_icon.svg",
                        glowColor: "#4B3BDB",
                        height: "250",
                        width: "250",
                    },
                    {
                        title: "Identificação de oportunidades",
                        icon: "../assets/servicos/identificacao_icon.svg",
                        iconHover: "../assets/servicos/identificacao_icon.svg",
                        glowColor: "#4B3BDB",
                        height: "250",
                        width: "250",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default Ams;
